// Pages that belong to the signed-in STAFF app. Everything else (login screens, the Super
// Admin panel, the client portal / client app) must never be hijacked by a staff session.
export const isStaffAppPath = (p) =>
  !(p === '/' || p === '/register' || p === '/reset-password' || p === '/client-app'
    || p.startsWith('/superadmin') || p.startsWith('/client-portal') || p.startsWith('/portal/'));
